var map = {
	"./Iraq-taxform.jsx": 996874,
	"./albania-taxform.jsx": 688637,
	"./algeria-taxform.jsx": 576740,
	"./angola-taxform.jsx": 310611,
	"./argentina-taxform.jsx": 4374,
	"./armenia-taxform.jsx": 389884,
	"./australia-taxform.jsx": 177859,
	"./azerbaijan-taxform.jsx": 671322,
	"./bahrain-taxform.jsx": 637742,
	"./bangladesh-taxform.jsx": 918646,
	"./barbados-taxform.jsx": 499815,
	"./belarus-taxform.jsx": 487353,
	"./benin-taxform.jsx": 447503,
	"./bhutan-taxform.jsx": 243501,
	"./bosnia-and-herzegovina-taxform.jsx": 808362,
	"./botswana-taxform.jsx": 762032,
	"./brazil-taxform.jsx": 550916,
	"./cambodia-taxform.jsx": 469023,
	"./cameroon-taxform.jsx": 605893,
	"./canada-pst-taxform.jsx": 852457,
	"./canada-qst-taxform.jsx": 430708,
	"./canada-taxform.jsx": 187595,
	"./chile-taxform.jsx": 911626,
	"./china-taxform.jsx": 447316,
	"./colombia-taxform.jsx": 488899,
	"./egypt-taxform.jsx": 991876,
	"./emea-taxform.jsx": 969997,
	"./empty-taxform.jsx": 294206,
	"./eswatini-taxform.jsx": 927867,
	"./fiji-taxform.jsx": 668013,
	"./french-guiana-taxform.jsx": 563733,
	"./french-polynesia-taxform.jsx": 209216,
	"./georgia-taxform.jsx": 515333,
	"./ghana-taxform.jsx": 748536,
	"./global-taxform.jsx": 654496,
	"./guatemala-taxform.jsx": 781682,
	"./iceland-taxform.jsx": 808967,
	"./india-taxform.jsx": 657768,
	"./indonesia-taxform.jsx": 190067,
	"./israel-taxform.jsx": 380081,
	"./ivory-coast-taxform.jsx": 120923,
	"./japan-taxform.jsx": 657589,
	"./kazakhstan-taxform.jsx": 151799,
	"./kenya-taxform.jsx": 630181,
	"./kyrgyzstan-taxform.jsx": 845221,
	"./laos-taxform.jsx": 577562,
	"./malaysia-taxform.jsx": 683348,
	"./maldives-taxform.jsx": 571218,
	"./mauritius-taxform.jsx": 781588,
	"./mayotte-taxform.jsx": 583542,
	"./mexico-taxform.jsx": 742120,
	"./moldova-taxform.jsx": 690245,
	"./morocco-taxform.jsx": 989575,
	"./mozambique-taxform.jsx": 593575,
	"./myanmar-taxform.jsx": 503916,
	"./nepal-taxform.jsx": 90627,
	"./new-caledonia-taxform.jsx": 489902,
	"./newzealand-taxform.jsx": 946996,
	"./nigeria-taxform.jsx": 478476,
	"./north-macedonia-taxform.jsx": 37480,
	"./norway-taxform.jsx": 529207,
	"./oman-taxform.jsx": 84580,
	"./pakistan-taxform.jsx": 323780,
	"./panama-taxform.jsx": 363773,
	"./peru-taxform.jsx": 588435,
	"./philippines-taxform.jsx": 933276,
	"./russia-taxform.jsx": 777894,
	"./saint-pierre-and-miquelon-taxform.jsx": 234497,
	"./saudi-arabia-taxform.jsx": 199682,
	"./senegal-taxform.jsx": 420764,
	"./serbia-taxform.jsx": 90731,
	"./singapore-taxform.jsx": 451083,
	"./south-africa-taxform.jsx": 146455,
	"./south-korea-taxform.jsx": 235767,
	"./south-sudan-taxform.jsx": 128108,
	"./sri-lanka-taxform.jsx": 299571,
	"./suriname-taxform.jsx": 799167,
	"./taiwan-taxform.jsx": 928185,
	"./tajikistan-taxform.jsx": 714371,
	"./tanzania-taxform.jsx": 832291,
	"./thailand-taxform.jsx": 632628,
	"./the-bahamas-taxform.jsx": 236388,
	"./turkey-taxform.jsx": 454051,
	"./uganda-taxform.jsx": 833909,
	"./ukraine-taxform.jsx": 543886,
	"./united-arab-emirates-taxform.jsx": 413590,
	"./uruguay-taxform.jsx": 762993,
	"./us-cert-taxform.jsx": 678554,
	"./uzbekistan-taxform.jsx": 996555,
	"./venezuela-taxform.jsx": 910388,
	"./vietnam-taxform.jsx": 85445,
	"./viewtaxforms/albania-viewtaxform.jsx": 9362,
	"./viewtaxforms/algeria-viewtaxform.jsx": 620631,
	"./viewtaxforms/angola-viewtaxform.jsx": 943320,
	"./viewtaxforms/argentina-viewtaxform.jsx": 378889,
	"./viewtaxforms/armenia-viewtaxform.jsx": 483399,
	"./viewtaxforms/azerbaijan-viewtaxform.jsx": 691525,
	"./viewtaxforms/bahrain-viewtaxform.jsx": 818421,
	"./viewtaxforms/bangladesh-viewtaxform.jsx": 76645,
	"./viewtaxforms/barbados-viewtaxform.jsx": 874964,
	"./viewtaxforms/base-viewtaxform.jsx": 500349,
	"./viewtaxforms/belarus-viewtaxform.jsx": 677418,
	"./viewtaxforms/benin-viewtaxform.jsx": 188512,
	"./viewtaxforms/bosnia-and-herzegovina-viewtaxform.jsx": 551373,
	"./viewtaxforms/botswana-viewtaxform.jsx": 166803,
	"./viewtaxforms/brazil-viewtaxform.jsx": 33788,
	"./viewtaxforms/cambodia-viewtaxform.jsx": 796124,
	"./viewtaxforms/cameroon-viewtaxform.jsx": 232402,
	"./viewtaxforms/canada-viewtaxform.jsx": 768068,
	"./viewtaxforms/chile-viewtaxform.jsx": 842609,
	"./viewtaxforms/china-viewtaxform.jsx": 647831,
	"./viewtaxforms/colombia-viewtaxform.jsx": 914684,
	"./viewtaxforms/default-viewtaxform.jsx": 43477,
	"./viewtaxforms/egypt-viewtaxform.jsx": 860443,
	"./viewtaxforms/empty-viewtaxform.jsx": 239953,
	"./viewtaxforms/eswatini-viewtaxform.jsx": 435656,
	"./viewtaxforms/fiji-viewtaxform.jsx": 917726,
	"./viewtaxforms/french-guiana-viewtaxform.jsx": 228514,
	"./viewtaxforms/french-polynesia-viewtaxform.jsx": 908059,
	"./viewtaxforms/georgia-viewtaxform.jsx": 13410,
	"./viewtaxforms/ghana-viewtaxform.jsx": 336363,
	"./viewtaxforms/global-viewtaxform.jsx": 781787,
	"./viewtaxforms/guatemala-viewtaxform.jsx": 681705,
	"./viewtaxforms/iceland-viewtaxform.jsx": 805604,
	"./viewtaxforms/indonesia-viewtaxform.jsx": 288088,
	"./viewtaxforms/israel-viewtaxform.jsx": 326250,
	"./viewtaxforms/ivory-coast-viewtaxform.jsx": 550632,
	"./viewtaxforms/japan-viewtaxform.jsx": 538370,
	"./viewtaxforms/kazakhstan-viewtaxform.jsx": 126068,
	"./viewtaxforms/kenya-viewtaxform.jsx": 196154,
	"./viewtaxforms/laos-viewtaxform.jsx": 767993,
	"./viewtaxforms/malaysia-viewtaxform.jsx": 962511,
	"./viewtaxforms/mauritius-viewtaxform.jsx": 233447,
	"./viewtaxforms/mayotte-viewtaxform.jsx": 810317,
	"./viewtaxforms/mexico-viewtaxform.jsx": 238879,
	"./viewtaxforms/moldova-viewtaxform.jsx": 72638,
	"./viewtaxforms/morocco-viewtaxform.jsx": 79900,
	"./viewtaxforms/mozambique-viewtaxform.jsx": 953492,
	"./viewtaxforms/myanmar-viewtaxform.jsx": 131975,
	"./viewtaxforms/nepal-viewtaxform.jsx": 772860,
	"./viewtaxforms/new-caledonia-viewtaxform.jsx": 76325,
	"./viewtaxforms/nigeria-viewtaxform.jsx": 983915,
	"./viewtaxforms/north-macedonia-viewtaxform.jsx": 467499,
	"./viewtaxforms/norway-viewtaxform.jsx": 519368,
	"./viewtaxforms/oman-viewtaxform.jsx": 365843,
	"./viewtaxforms/pakistan-viewtaxform.jsx": 722399,
	"./viewtaxforms/panama-viewtaxform.jsx": 373221,
	"./viewtaxforms/peru-viewtaxform.jsx": 980072,
	"./viewtaxforms/philippines-viewtaxform.jsx": 482023,
	"./viewtaxforms/saint-pierre-and-miquelon-viewtaxform.jsx": 582074,
	"./viewtaxforms/saudi-arabia-viewtaxform.jsx": 524021,
	"./viewtaxforms/senegal-viewtaxform.jsx": 985203,
	"./viewtaxforms/south-africa-viewtaxform.jsx": 53588,
	"./viewtaxforms/south-korea-viewtaxform.jsx": 721992,
	"./viewtaxforms/sri-lanka-viewtaxform.jsx": 963200,
	"./viewtaxforms/suriname-viewtaxform.jsx": 381132,
	"./viewtaxforms/taiwan-viewtaxform.jsx": 967738,
	"./viewtaxforms/tajikistan-viewtaxform.jsx": 268892,
	"./viewtaxforms/tanzania-viewtaxform.jsx": 326112,
	"./viewtaxforms/thailand-viewtaxform.jsx": 273719,
	"./viewtaxforms/the-bahamas-viewtaxform.jsx": 564111,
	"./viewtaxforms/turkey-viewtaxform.jsx": 868268,
	"./viewtaxforms/uganda-viewtaxform.jsx": 353806,
	"./viewtaxforms/ukraine-viewtaxform.jsx": 821141,
	"./viewtaxforms/united-arab-emirates-viewtaxform.jsx": 226505,
	"./viewtaxforms/uruguay-viewtaxform.jsx": 83606,
	"./viewtaxforms/us-viewtaxform.jsx": 893178,
	"./viewtaxforms/uzbekistan-viewtaxform.jsx": 456848,
	"./viewtaxforms/venezuela-viewtaxform.jsx": 407987,
	"./viewtaxforms/vietnam-viewtaxform.jsx": 705130,
	"./viewtaxforms/wallis-and-futuna-viewtaxform.jsx": 509314,
	"./viewtaxforms/zambia-viewtaxform.jsx": 674346,
	"./viewtaxforms/zimbabwe-viewtaxform.jsx": 598025,
	"./wallis-and-futuna-taxform.jsx": 691713,
	"./zambia-taxform.jsx": 468705,
	"./zimbabwe-taxform.jsx": 15378
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7989;